<div class="heat">
  <div class="heat-grid">
    <div class="heat-row" *ngFor="let row of rowsVm" [style.marginBottom.px]="gap">
      <div class="heat-row-label">{{ row.label }}</div>
      <div class="heat-cells" [style.gridTemplateColumns]="colTemplate" [style.gap.px]="gap">
        <div class="cell" *ngFor="let cell of row.cells"
             [style.background]="cell.color"
             [style.borderRadius.px]="borderRadius"
             [title]="cell.tooltip"></div>
      </div>
    </div>

    <div class="heat-axis">
      <div class="heat-row-label spacer"></div>
      <div class="heat-ticks" [style.gridTemplateColumns]="colTemplate" [style.columnGap.px]="gap">
        <span class="tick" *ngFor="let t of colTicksVm"
              [style.gridColumnStart]="t.col + 1"
              [style.justifySelf]="t.align">{{ t.label }}</span>
      </div>
    </div>
  </div>
  <div class="heat-legend">
    <span>{{ compactActive ? legendLowCompact : legendLow }}</span>
    <span class="sw"><i *ngFor="let c of legendSwatches" [style.background]="c"></i></span>
    <span>{{ compactActive ? legendHighCompact : legendHigh }}</span>
  </div>
</div>
